// theme.js - 共享主题配置
// 所有组件都从这里 import theme

export const theme = {
  bg: '#0d1117',
  bgCard: '#161b22',
  border: '#30363d',
  teal: '#2dd4bf',
  cyan: '#22d3ee',
  purple: '#a855f7',
  text: '#e6edf3',
  textMuted: '#c9d1d9',
  textDark: '#8b949e',
  green: '#22c55e',
  red: '#f85149',
  neutral: '#d29922',
  blue: '#58a6ff',
};

export default theme;
